export default {
	URL: 'https://api-viva.infinitum-ti.com',
	API_URL: 'https://api-viva.infinitum-ti.com/api',
	OAPI_URL: 'https://api-viva.infinitum-ti.com/oapi',
	// URL: 'http://localhost:2384',
	// API_URL: 'http://localhost:2384/api',
	// OAPI_URL: 'http://localhost:2384/oapi',
}
